import { Optional } from '../../../../types.js';
import { groupBy } from '../../../../visualizations/common/groupBy.js';
import { optionalMin, optionalMax } from '../../../common/math.js';
import { seriesTypeFlatDataset } from '../../render-groups/types.js';
import { seriesLine } from '../../types.js';
import { LineRenderGroup, lineRenderGroupData } from './types.js';
export const getLineRenderGroups = (set: seriesTypeFlatDataset): LineRenderGroup[] => {
  const groups = Object.values(groupBy(set, x => `${x.series.yTarget}:${x.series.name}`));
  const collection: LineRenderGroup[] = [];
  for (const group of groups) {
    let minValue: Optional<number>;
    let maxValue: Optional<number>;
    const line: lineRenderGroupData[] = [];
    for (const {
      datapoint,
      series
    } of group) {
      const hasValue = datapoint.value != null;
      if (hasValue) {
        minValue = optionalMin(minValue, datapoint.value);
        maxValue = optionalMax(maxValue, datapoint.value);
      }
      line.push({
        key: datapoint.key,
        value: datapoint.value,
        showPointLabel: series.showPointLabels !== false
      });
    }
    const serie = group[0].series as seriesLine;
    collection.push({
      type: 'line',
      yTarget: serie.yTarget ?? 'left',
      strokeDashed: dashArray(serie.strokeDashed ?? false),
      strokeWidth: strokeWidth(serie.strokeWidth),
      color: serie.color,
      name: serie.name,
      curved: serie.curved ?? false,
      line,
      minValue,
      maxValue
    });
  }
  return collection;
};
const strokeWidth = (strokeWidth: number | undefined) => {
  const defaultSize = 2;
  return Math.max(1, strokeWidth ? Number(strokeWidth) : defaultSize);
};
const dashArray = (strokeDashed: boolean) => {
  if (!strokeDashed) {
    return '';
  }
  const dashLength = 6;
  const dashSpacing = 6;
  return `${dashLength}, ${dashSpacing}`;
};